module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6b6375a1dc4d81ac925afa1e521d9cb.png";